export const getIonicIcon = (materialIcon: string): string => {
  // Map Material Design icons to Ionic icons
  const iconMap: { [key: string]: string } = {
    article: 'newspaper',
    calculate: 'calculator',
    analytics: 'bar-chart',
    assessment: 'analytics',
    find_in_page: 'search',
    location_on: 'location',
    compare_arrows: 'swap-horizontal',
    monetization_on: 'pricetag',
    info: 'information-circle',
    settings: 'settings',
    chart: 'bar-chart',
    table_chart: 'grid',
  };

  return iconMap[materialIcon] || 'ellipse';
};
